import { hasOmsAdminAccess } from './adminAccess'

/** Platform admins (/admin/products) and supplier admins (/supplier/products). */
export const canViewProductPriceAudit = account =>
  hasOmsAdminAccess(account) || Boolean(account?.supplierAdmin)
